"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageTop = void 0;
const global_1 = require("../global");
/**
 * ページトップボタン
 */
const pageTop = () => {
    const pageTopButton = document.getElementById("js-pageTop");
    let done = false;
    const showButton = () => {
        const scrollTop = window.scrollY;
        if (scrollTop < global_1.header.clientHeight) {
            pageTopButton.classList.add("is-hide");
        }
        else {
            pageTopButton.classList.remove("is-hide");
        }
    };
    const fixedButton = () => {
        const fixedBanner = document.getElementById("js-fixedBanner");
        if (fixedBanner != null && !fixedBanner.classList.contains("is-hidden")) {
            const h = fixedBanner.clientHeight;
            pageTopButton.style.transform = `translateY(${-h}px)`;
        }
        else {
            pageTopButton.style.transform = "";
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    pageTopButton.classList.remove("is-fixed");
                }
                else {
                    pageTopButton.classList.add("is-fixed");
                }
            });
        }, {
            root: null,
            rootMargin: "0px 0px",
            threshold: 0,
        });
        observer.observe(global_1.footer);
    };
    function handleScroll() {
        showButton();
        fixedButton();
        done = false;
    }
    function onScroll() {
        if (!done) {
            requestAnimationFrame(handleScroll);
            done = true;
        }
    }
    window.addEventListener("scroll", onScroll);
};
exports.pageTop = pageTop;
